import { createContext } from "react";

import { Stack } from "types/generated";
import { AccessResult } from "utils/access";

export type StackSettingsContextDataProps = {
  stackSettings: Stack;
  canUpdateStack: AccessResult;
};

export const StackSettingsContextData = createContext<StackSettingsContextDataProps | undefined>(
  undefined
);
